/**
 * Keeps secrets out of logs. The browser runs these before it reports an error, and the server runs them again
 * before it writes a line, so a token pasted into an error message never reaches a log.
 */

/** Replaces bearer tokens, JWTs and URL query values in free text (error messages, stacks). */
export function scrubSecrets(text: string): string {
  return text
    .replace(/Bearer\s+[A-Za-z0-9._~+/=-]+/gi, 'Bearer [redacted]')
    .replace(/\bcpgp_[A-Za-z0-9_-]+/g, 'cpgp_[redacted]')
    .replace(/eyJ[A-Za-z0-9_-]{4,}\.[A-Za-z0-9_-]{4,}\.[A-Za-z0-9_-]*/g, '[token]')
    .replace(/([?&][^=&#\s]+=)[^&#\s'"):]+/g, '$1[redacted]') // stops at ':' so stack line numbers stay
}

/** A path with its query values hidden: `/api/orders?from=2026&token=abc` becomes `/api/orders?from=*&token=*`. */
export function redactQuery(pathAndQuery: string): string {
  const q = pathAndQuery.indexOf('?')
  if (q === -1) return pathAndQuery
  const path = pathAndQuery.slice(0, q)
  const keys = pathAndQuery
    .slice(q + 1)
    .split('#')[0]!
    .split('&')
    .filter(Boolean)
    .map((pair) => `${pair.split('=')[0]}=*`)
  return keys.length ? `${path}?${keys.join('&')}` : path
}
